import Header from 'components/Header/Header';
import { SITE } from 'config/config';
import { twMerge } from 'tailwind-merge';
import MatchResult from './MatchResult';

const PrizeStructure = () => {
  return (
    <div className={twMerge(SITE, 'w-full h-full')}>
      <img
        src="bg.png"
        alt="Background"
        className="w-full h-full fixed right-0 bottom-0 object-cover object-center"
      />
      <img
        src="/assets/images/flag_1.png"
        alt="Flag left"
        className="fixed top-0 left-0 z-0 w-[120px] md:w-[180px] lg:w-[220px] h-auto pointer-events-none"
      />
      <img
        src="/assets/images/flag_2.png"
        alt="Flag right"
        className="fixed top-0 right-0 z-0 w-[120px] md:w-[180px] lg:w-[220px] h-auto pointer-events-none"
      />
      <div className="container relative z-10 pb-[24px] md:pb-[32px] px-2">
        <Header />

        {/* Header Cơ Cấu Giải Thưởng */}
        <div
          className="flex flex-col max-w-[1000px] mx-auto lg:flex-row justify-center items-center md:p-10 p-5 mt-2 mb-4 w-full h-auto min-h-[280px] relative bg-white bg-white/95 border-2 border-solid shadow shadow-primary md:pb-8 md:pt-4 rounded-2xl"
          style={{
            background: '#FFFFFF80',
            borderColor: '#f27121',
            borderRadius: '1.5rem'
          }}
        >
          <div className="md:max-w-[250px] max-w-[220px]">
            <img
              src="/assets/images/cocau/cocau.png"
              alt=""
              className="w-full h-full object-contain"
            />
          </div>

          {/* Bảng Cơ Cấu Giải Thưởng từ Figma */}
          <div className="w-full mx-auto lg:mt-0 px-2 mt-3 lg:ml-5">
            <table
              className="w-full text-center"
              style={{ borderCollapse: 'separate', borderSpacing: 0 }}
            >
              <thead>
                <tr>
                  <th className="bg-[#f27121] text-white text-[16px] sm:text-[18px] md:text-[20px] font-semibold py-2 px-2 rounded-tl-[9px]">
                    Cấp độ VIP
                  </th>
                  <th className="bg-[#f27121] text-white text-[16px] sm:text-[18px] md:text-[20px] font-semibold py-2 px-2 rounded-tr-[9px]">
                    Tiền Thưởng
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-transparent">
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold text-[#f27121] py-3 px-2">
                    VIP 0 - VIP 2
                  </td>
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2">
                    28
                  </td>
                </tr>
                <tr className="bg-[#F6F6F6]">
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold text-[#f27121] py-3 px-2">
                    VIP 3 - VIP 10
                  </td>
                  <td
                    className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2"
                    style={{ opacity: 0.9 }}
                  >
                    88
                  </td>
                </tr>
                <tr className="bg-transparent">
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold text-[#f27121] py-3 px-2">
                    VIP 11 - VIP 15
                  </td>
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2">
                    188
                  </td>
                </tr>
                <tr className="bg-[#F6F6F6]">
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold text-[#f27121] py-3 px-2">
                    VIP 16 - VIP 20
                  </td>
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2">
                    288
                  </td>
                </tr>
                <tr className="bg-transparent">
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold text-[#f27121] py-3 px-2">
                    VIP 21 - VIP 30
                  </td>
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2">
                    388
                  </td>
                </tr>
                <tr className="bg-[#F6F6F6]">
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold text-[#f27121] py-3 px-2">
                    VIP 31 - VIP 50
                  </td>
                  <td
                    className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2"
                    style={{ opacity: 0.9 }}
                  >
                    588
                  </td>
                </tr>
                <tr className="bg-transparent">
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-bold text-[#f27121] py-3 px-2">
                    VIP 51 - VIP 60
                  </td>
                  <td className="text-[15px] sm:text-[17px] md:text-[19px] font-medium text-black py-3 px-2">
                    888
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <MatchResult />
      </div>
    </div>
  );
};

export default PrizeStructure;
